module.exports = __webpack_public_path__ + "static/img/hangyeli3.19ef4b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/hangyeli3.png
// module id = qzRp
// module chunks = 5